<template>
  <div class="box-row col-12 p-0">
    <h6>{{ title }}</h6>
    <slot>
      <span>{{ value }}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: "customLabel",
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    }
  },
}
</script>

<style scoped>
h6 {
  text-transform: uppercase;
  font-size: 12px;
  font-family: Roboto-Light;
  color: #a8a8a8;
  margin: 0;
}

.box-row {
  margin: 10px 0;
}

.box-row span {
  font-family: Roboto-Black;
  color: #000 !important;
  font-size: 26px;
}
</style>